import { useEffect, useState } from 'react';
import { BASE_URL } from '../constants/urls';
import axios from 'axios';

const useStoreTopCashback = () => {

    const [topCashbackStores, setTopCashbackStores] = useState([]);
    const [loadingTopCashbackStores, setLoadingTopCashbackStores] = useState(true);
    const [errorTopCashbackStores, setErrorTopCashbackStores] = useState(null);
    
    useEffect(() => {

        const fetchstoresTopCashback = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/store/top-cashback`, {
                    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`}
                });
                setTopCashbackStores(res.data)
            } catch (err) {
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                errorTopCashbackStores(msg);
            } finally {
                setLoadingTopCashbackStores(false);
            }
        };

        fetchstoresTopCashback();
    }, []);

    return { topCashbackStores, loadingTopCashbackStores, setErrorTopCashbackStores };
}

export default useStoreTopCashback
